// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EK3F","colMin":"styles_colMin__3HWMs"};